<main class="w-full min-h-screen flex items-center justify-center bg-repeat-round">
	<div class="w-full max-w-2xl flex items-center justify-center h-full py-20">
		<edu-sign-up-form></edu-sign-up-form>
	</div>
</main>
